var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4375 0.5H2.75V1.35938H0.6875C0.309375 1.35938 0 1.66875 0 2.04688V10.8125C0 11.1906 0.309375 11.5 0.6875 11.5H10.3125C10.6906 11.5 11 11.1906 11 10.8125V2.04688C11 1.66875 10.6906 1.35938 10.3125 1.35938H8.25V0.5H7.5625V1.35938H3.4375V0.5ZM7.5625 2.90625V2.04688H3.4375V2.90625H2.75V2.04688H0.6875V3.9375H10.3125V2.04688H8.25V2.90625H7.5625ZM10.3125 4.625H0.6875V10.8125H10.3125V4.625ZM7.5625 6H9.28125V6.6875H7.5625V6ZM9.28125 8.57812H7.5625V9.26562H9.28125V8.57812ZM4.64062 6H6.35938V6.6875H4.64062V6ZM6.35938 8.57812H4.64062V9.26562H6.35938V8.57812ZM1.71875 6H3.4375V6.6875H1.71875V6ZM3.4375 8.57812H1.71875V9.26562H3.4375V8.57812Z",
    fill: "#01459D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3b5e7c99589869805dfa6be1a7128cc3.svg";
export { ForwardRef as ReactComponent };